<!--
 * @Author: hongqi
 * @LastEditors: hongqi
 * @change:qianye
 * @Date: 2021-01-05 13:48:41
 * @LastEditTime: 2021-01-09 10:21:06
-->
<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div
        class="iconfont"
        
      >
      <img :src="item.url===$route.path ?item.icon2:item.icon1" alt="">
      </div>
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<style lang="scss" scoped>
.iconfont{ 
  img{
    width: 22px;
    height: 22px;
  }
}
</style>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: require('../assets/newImg/index1_select.png'),
          icon2: require('../assets/newImg/index1_selected.png'),
          url: "/"
        },
        {
          name: "自营商品",
          icon1: require('../assets/newImg/index2_select.png'),
          icon2: require('../assets/newImg/index2_selected.png'),
          url: "/goods_list"
        },
        {
          name: "积分商品",
          icon1: require('../assets/newImg/index3_select.png'),
          icon2:  require('../assets/newImg/index3_selected.png'),
          url: "/integral"
        },
        
        {
          name: "购物车",
          icon1:  require('../assets/newImg/index4_select.png'),
          icon2:require('../assets/newImg/index4_selected.png'),
          url: "/cart"
        },
        {
          name: "我的",
          icon1: require('../assets/newImg/index5_select.png'),
          icon2: require('../assets/newImg/index5_selected.png'),
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
